// «Библиотека сцены» в генераторе: «@» в промпте, готовые персонажи, «Локация» и «Предмет» в меню фото-слота.
// Кому она открыта, решает рубильник в админке («Настройки → Меню сайта», строка под «Сценой»; тот же — на странице
// «Библиотека сцены»). Закрыта — человеку остаются его персонажи, как было до библиотеки. Сервер проверяет то же
// самое сам (scene_assets.library_open): спрятать пункты мало.
import { featureOpen, navMode } from '../api/nav'
import { useAuth } from '../context/AuthContext'
import { isStaff } from '../utils/roles'
import { useNavModes } from './useNavModes'

export function useSceneTools(): boolean {
	const { user } = useAuth()
	const { modes } = useNavModes()
	// Пока карта режимов грузится, действует значение из кода («только сотрудникам») — у клиента ничего не мигнёт.
	return !!user && featureOpen(navMode(modes, 'scene_tools'), isStaff(user.role))
}
